export default "__VITE_ASSET__BoBC3d2a__"